import ServiceCombinationsPage from '_pages/ServiceCombinationsPage/ServiceCombinationsPage';

export default ServiceCombinationsPage;
